module.exports = __webpack_public_path__ + "images/icons/cards/master-card-85448e91.svg";